export default __webpack_public_path__ + "static/media/Securities.602e8cc8.png";